import { Button, Divider, Empty, Input, Row, Tree } from 'antd';
import { useCallback, useContext } from 'react';

import { PREFIX } from '@app/constants';
import { useWindowSize } from '@app/hooks';
import {
  CHF_SERVICE_CATEGORY_IDS,
  CHF_VISITS_FILTER,
} from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';

import {
  getFiltersArray,
  hideFilterBlock,
} from '@pages/Clients/ClientsList/utils';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

import '@pages/Clients/ClientsList/styles/Filters.desktop.scss';

const { Search } = Input;

export const VisitsCategories = ({
  filterGroupIndex,
}: {
  filterGroupIndex: number;
}) => {
  const {
    filters,
    allCategoriesAndServices,
    searchedCategories,
    setFilters,
    setSearchedCategories,
    handleDisabling,
    setUpServerDataChunk,
  } = useContext(ClientFiltersContext);
  const { innerWidth } = useWindowSize();

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchQuery = event.target?.value.toLowerCase() || '';

    setSearchedCategories(
      allCategoriesAndServices

        .filter((item) => {
          const categoryName =
            'Name' in item && typeof item?.Name === 'string'
              ? item?.Name
              : typeof item?.title === 'string'
              ? item?.title
              : '';

          const isSearchedIntoCategories = String(categoryName || '')
            .toLowerCase()
            .includes(searchQuery);

          if (isSearchedIntoCategories) {
            return true;
          }
        })
        .map(({ key, title }) => ({ key, title }))
    );
  };

  const handleChecking: NClientsList.HandleChecking = useCallback(
    (checkedNodes) => {
      const handledValues = checkedNodes.map(({ key }) =>
        Number(`${key}`.split('-')[1])
      );

      const filtersByVisits: NClientsList.Filters['VisitsFilter'] =
        getFiltersArray<NClientsList.Filters['VisitsFilter']>({
          ...(filters.VisitsFilter.filter(
            (item, index) => index !== filterGroupIndex
          ) || []),
          [filterGroupIndex]: {
            ...filters.VisitsFilter[filterGroupIndex],
            Values: [
              {
                ...filters?.VisitsFilter?.[filterGroupIndex]?.Values?.[0],
                ServiceCategoryIds:
                  handledValues.length > 0 ? handledValues : null,
              },
            ],
          },
        });

      const result = {
        ...filters,
        VisitsFilter: filtersByVisits,
      };

      setFilters(result);
    },
    [filters, filterGroupIndex, setFilters]
  );

  return (
    <div
      className={`${PREFIX}chf-visits-categories`}
      onClick={(e) => e.stopPropagation()}
    >
      <Search
        className="search-field"
        placeholder="Поиск по категориям"
        onChange={onChange}
      />
      {searchedCategories.length > 0 ? (
        <Tree
          className="items-tree"
          checkable
          onCheck={(_, { checkedNodes }) => handleChecking(checkedNodes)}
          checkedKeys={
            filters.VisitsFilter?.[
              filterGroupIndex
            ]?.Values?.[0]?.ServiceCategoryIds?.map(
              (item) => `parent-${item}`
            ) || []
          }
          treeData={searchedCategories}
        />
      ) : (
        <Empty />
      )}
      <Divider className="button-divider" />
      <Row justify="end">
        <Button
          type="primary"
          size="small"
          disabled={handleDisabling(
            CHF_VISITS_FILTER,
            CHF_SERVICE_CATEGORY_IDS,
            false,
            '',
            filterGroupIndex
          )}
          onClick={() => {
            setUpServerDataChunk(
              CHF_VISITS_FILTER,
              CHF_SERVICE_CATEGORY_IDS,
              false,
              '',
              filterGroupIndex
            );

            hideFilterBlock(
              '.visits-categories-label',
              innerWidth,
              filterGroupIndex
            );
          }}
        >
          Выбрать
        </Button>
      </Row>
    </div>
  );
};
